import type { InstallSurface } from "../pwaInstall";

export function InstallHint({
  mode,
  onInstall,
  onDismiss,
}: {
  mode: InstallSurface;
  onInstall?: () => void;
  onDismiss?: () => void;
}) {
  if (mode === "hidden") return null;
  return (
    <div className="install-hint" data-testid="install-hint" data-mode={mode} role="region" aria-label="Install Dispatch Mobile">
      <p>
        {mode === "prompt"
          ? "Install Dispatch Mobile for a full-screen home-screen app."
          : "On iPhone, tap Share, then Add to Home Screen. Safari is the reliable path — there is no Install button."}
      </p>
      {mode === "prompt" ? (
        <button type="button" className="btn" data-testid="install-prompt" onClick={onInstall}>
          Install
        </button>
      ) : null}
      <button type="button" className="btn ghost" data-testid="install-dismiss" onClick={onDismiss}>
        Not now
      </button>
    </div>
  );
}
